module.exports = __webpack_public_path__ + "static/img/logo_text.ea8e8da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_text.png
// module id = jpOh
// module chunks = 1